(function (scope) {
  'use strict';
  const unsafe = () => new Error('旧商品の仕様を自動移行できません。お手数ですが、お問い合わせください。');
  const customized = item => Object.keys(item.properties || {}).length > 0 || !!item.selling_plan_allocation;
  function plan(cart, mapping) {
    const updates = {};
    const targets = new Map();
    const legacy = cart.items.filter(item => mapping.variants[String(item.variant_id)]);
    for (const item of legacy) {
      const target = String(mapping.variants[String(item.variant_id)].id);
      if (!/^\d+$/.test(target) || target === String(item.variant_id) || customized(item)) throw unsafe();
      updates[item.key] = 0;
      targets.set(target, (targets.get(target) || 0) + item.quantity);
    }
    for (const [target, quantity] of targets) {
      const existing = cart.items.filter(item => String(item.variant_id) === target);
      if (existing.length > 1 || existing.some(customized)) throw unsafe();
      updates[target] = quantity + existing.reduce((sum, item) => sum + item.quantity, 0);
    }
    return {updates, migrated: legacy.length > 0, targets: Object.fromEntries(targets)};
  }
  function redirect(href, mapping, root) {
    const url = new URL(href);
    const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
    if (!match) return null;
    const handle = decodeURIComponent(match[1]);
    const product = mapping.products[handle];
    if (!product) return null;
    const variant = url.searchParams.get('variant');
    const replacement = variant ? mapping.variants[variant] : null;
    if (variant && !replacement) throw unsafe();
    url.pathname = root + 'products/' + encodeURIComponent(replacement?.handle || product);
    if (replacement) url.searchParams.set('variant', String(replacement.id));
    return url.href;
  }
  scope.DealerLegacyMigration = {plan, redirect};
  if (typeof module !== 'undefined') module.exports = scope.DealerLegacyMigration;
})(typeof window !== 'undefined' ? window : globalThis);
